import api from '@/services/api';
import {mapActions} from 'vuex';
import Modal from '@/components/Partials/Modal.vue';

export default {
    props: ['name', 'bnr', 'amount', 'minimum', 'id', 'type', 'sold', 'image', 'realSales'],

    data() {
        return {
            sales: 0,
            showModal: false,
        };
    },

    components: {
        Modal,
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),

        /**
         * Confirt change for product sales
         */
        confirmChange(autoincrement = '') {
            if (autoincrement === '+') {
                this.sales = Number(this.sales) + 1;
            }
            if (autoincrement === '-') {
                this.sales = Number(this.sales) - 1;
            }

            const params = new URLSearchParams();
            if (this.type === 'product') {
                params.append('sales', Number(this.sales));
                api.post(`/api/promotion_product/${this.id}/change_stock`, params)
                    .then(() => {
                        this.storePromotion();
                        this.$emit('close-modal')
                    })
                    .catch((error) => {
                        //commit('SHOW_LOGIN_ERRORS', error.response.data);
                    });
            } else {
                params.append('sales', this.sales);
                api.post(`/api/promotion_gift/${this.id}/change_stock`, params)
                    .then(() => {
                        this.storePromotion();
                        this.$emit('close-modal')
                    })
                    .catch((error) => {
                        //commit('SHOW_LOGIN_ERRORS', error.response.data);
                    });
            }

            this.$emit('close-modal')
        }
    },

    mounted() {
        this.$refs['items-sold'].select()
        this.sales = this.realSales;
    },
}